import { useState } from 'react'
import { PageTemplate } from '@/components/templates'
import { CONTAINER_SIZES } from '@/constants'
import { 
  PartnerPortalTabs, 
  PartnerPortalContent 
} from '@/components/partner-portal'

const PartnerPortalScreen = () => {
  const [activeTab, setActiveTab] = useState('api-keys')

  const resources = [
    {
      id: '1',
      title: 'Partner API Documentation',
      description: 'Complete API reference for integration',
      type: 'documentation',
      downloadUrl: '/api/docs',
    },
    {
      id: '2',
      title: 'Marketing Materials',
      description: 'Logos, banners, and promotional content',
      type: 'assets',
      downloadUrl: '/marketing-kit',
    },
    {
      id: '3',
      title: 'Commission Structure Guide',
      description: 'Detailed breakdown of commission rates',
      type: 'guide',
      downloadUrl: '/commission-guide',
    },
  ]

  return (
    <PageTemplate
      title="Partner Portal"
      subtitle="Manage your partnerships and track performance"
      maxWidth={CONTAINER_SIZES.WIDE}
    >
      <div className="space-y-6">
        {/* Tabs */}
        <PartnerPortalTabs 
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        
        {/* Content */}
        <PartnerPortalContent 
          activeTab={activeTab}
          resources={resources}
        />
      </div>
    </PageTemplate>
  )
}

export default PartnerPortalScreen 